import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useAlignment = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    function handleClick(alignment: Partial<TextBox["alignment"]>) {
        dispatch(
            setSettings({
                id: textBox.id,
                alignment: {
                    ...textBox.alignment,
                    ...alignment,
                },
            }),
        );
    }
    return { handleClick };
};
